import { TableHead, SearchData } from "../../../../common/dataClass/Default"
import { Listing } from '../listing/class'

/**搜索数据 */
class ReplenishmentSearchData extends SearchData{
  constructor() {
    super()
    /**店铺 */
    this.store = ''
    /**创建日期 */
    this.createdDate = ''
    /**交货日期 */
    this.deliveryDate = ''
    /**状态 */
    this.status = ''
  }
  /**搜索数据请求体 */
  get getSearchAxiosBody(){
    return {
      page: this.page,
      row: 10,
      saleStatus: 0,
      storeName: this.store? this.store : null,
      countryArea: this.countrySite? this.countrySite : null,
      textFilter: this.text? this.text : null
    }
  }
}

/**发补货计划单表头 */
class ReplenishmentTableHead extends TableHead{
  constructor(name, prop, width, obj) {
    super(name, prop, width, obj)
  }
}

/**发补货装箱数据 */
class ReplenishmentNum extends Listing{
  constructor(bool = false){
    super()
    /**发补货数量 */
    this.num = null
    this['^input-_^num'] = false
    /**整箱数量 */
    this._numByBox = null
    /**已装数量 */
    this._numInBox = null
    /**尾货数量 */
    this._numByLast = null
    /**外箱标贴 */
    this.boxPdf = ''
    /**装箱状态 */
    this.boxStatus = -1
    /**操作状态 */
    this['^operate-_^'] = bool
  }
  set numByBox(val){
    this._numByBox = val
  }
  get numByBox(){
    return this._numByBox === null ? '------': this._numByBox
  }
  set numInBox(val){
    this._numInBox = val
  }
  get numInBox(){
    return this._numInBox === null ? '------': this._numInBox
  }
  set numByLast(val){
    this._numByLast = val
    if(val === null){
      this.boxStatus = -1
    }else if(val == 0){
      this.boxStatus = 0
    }else{
      this.boxStatus = 1
    }
  }
  get numByLast(){
    return this._numByLast === null ? '------': this._numByLast
  }
  get boxStatusText(){
    let obj = {
      '-1': '------',
      '0': '整箱',
      '1': '有尾箱'
    }
    return obj[this.boxStatus]
  }
  /**导入自身数据 */
  importParentData(obj){
    let keys = Object.keys(new Listing)
    keys.map(key => this[key] = obj[key])
  }
}

/**发补货创建数据 */
class Replenishment{
  constructor() {
    /**货件追踪编号 */
    this.amzonId = ''
    /**FBA编号 */
    this.fbaId = ''
    /**亚马逊仓库代码 */
    this.warehouseId = ''
    /**交货日期 */
    this.deliveryDate = ''
  }
}

class ReplenishmentNewModule{
  /**发补货计划单列表表头 */
  static NEWTABLEHEAD(){
    let arr = [
      new ReplenishmentTableHead('FBA发补货<br>计划单号', 'img', '150'),
      new ReplenishmentTableHead('店铺名称', 'storeName', '80'),
      new ReplenishmentTableHead('货件追踪编号<br>(Amazon ref. ID)', 'name', '150'),
      new ReplenishmentTableHead('FBA编号<br>(FBA ID)', 'name', '200'),
      new ReplenishmentTableHead('亚马逊<br>仓库代码', 'name', '100'),
      new ReplenishmentTableHead('国家<br>站点', 'countrySiteName', '100'),
      new ReplenishmentTableHead('ASIN<br>数量', 'unitName', '50'),
      new ReplenishmentTableHead('总箱数', 'stockPrice', '50'),
      new ReplenishmentTableHead('总重量<br>(kg)', 'getSavePriceByTable', '80'),
      new ReplenishmentTableHead('总体积<br>(M³)', 'getCostSummaryByTable', '80'),
      new ReplenishmentTableHead('采购单<br>创建日期', 'getNetProfitOfGoodsByTable', '100'),
      new ReplenishmentTableHead('要求交货日期<br>实际交货日期', 'getCostOfCommodityInvestmentByTable', '150'),
      new ReplenishmentTableHead('物流方式<br>物流渠道', 'getCommodityCollectionByTable', '80'),
      new ReplenishmentTableHead('已进仓数量<br>(详细)', 'getShowNumAndActualNumByTable', '120'),
      new ReplenishmentTableHead('始进仓数量<br>全进仓数量', 'disposalNum', '80'),
      new ReplenishmentTableHead('货运/上架周期<br>(天)', 'getShowNumAndActualNumByTable', '120'),
      new ReplenishmentTableHead('补货状况', 'stockPrice', '100'),
      new ReplenishmentTableHead('发补货计划单<br>创建日期', 'disposalNum', '120'),
      new ReplenishmentTableHead('操作', 'operate', '80'),
    ]
    return arr
  }
  /**发补货所有lisitng列表表头 */
  static NEWLISTINGTABLEHEAD(){
    let arr = [
      new ReplenishmentTableHead('选择', 'check', '40'),
      new ReplenishmentTableHead('商品图片', 'img', '100'),
      new ReplenishmentTableHead('商品型号', 'model', '100'),
      new ReplenishmentTableHead('商品名称', 'name', '150'),
      new ReplenishmentTableHead('店铺名称', 'store', '80'),
      new ReplenishmentTableHead('国家站点', 'getCountryName', '80'),
      new ReplenishmentTableHead('ASIN', 'asin', '120'),
      new ReplenishmentTableHead('计价单位', '_unit', '80'),
      new ReplenishmentTableHead('商品包装尺寸<br>(cm)', 'productSize', '150'),
      new ReplenishmentTableHead('商品包装重量<br>(kg/单位)', 'weight', '150'),
      new ReplenishmentTableHead('外箱包装尺寸<br>(cm)', 'boxSize', '150'),
      new ReplenishmentTableHead('外箱包装重量<br>(kg/单位)', 'boxWeight', '150'),
    ]
    return arr
  }
  /**发补货计划单装箱情况表头 */
  static NEWNUMTABLEHEAD(){
    let arr = [
      new ReplenishmentTableHead('商品图片', 'img', '80'),
      new ReplenishmentTableHead('商品名称', 'name', '150'),
      new ReplenishmentTableHead('ASIN', 'asin', '100'),
      new ReplenishmentTableHead('计价单位', '_unit', '100'),
      new ReplenishmentTableHead('商品包装尺寸<br>(cm)', 'productSize', '150'),
      new ReplenishmentTableHead('商品包装重量<br>(kg/单位)', 'weight', '150'),
      new ReplenishmentTableHead('外箱包装尺寸<br>(cm)', 'boxSize', '150'),
      new ReplenishmentTableHead('外箱包装重量<br>(kg/单位)', 'boxWeight', '150'),
      new ReplenishmentTableHead('装箱数量<br>(单位/箱)', 'boxNum', '100'),
      new ReplenishmentTableHead('发补货数量', '^input-_^num', '150'),
      new ReplenishmentTableHead('装箱数量<br>(箱)', 'numByBox', '100'),
      new ReplenishmentTableHead('已装数量', 'numInBox', '100'),
      new ReplenishmentTableHead('尾货数量', 'numByLast', '100'),
      new ReplenishmentTableHead('商品标贴<br>(UPC条码)', '^file-_^barCodeByListing', '150', { disable: true }),
      new ReplenishmentTableHead('外箱标贴<br>(仅支持PDF文件)', '^file-_^boxPdf', '180'),
      new ReplenishmentTableHead('装箱状态', 'boxStatusText', '100'),
      new ReplenishmentTableHead('操作', 'operate', '100'),
    ]
    return arr
  }
  /**新建尾箱表头 */
  static NEWTRUNKTABLEHEAD(){
    let arr = [
      new ReplenishmentTableHead('选择', 'check', '40'),
      new ReplenishmentTableHead('商品图片', 'img', '60'),
      new ReplenishmentTableHead('商品型号', 'model', '80'),
      new ReplenishmentTableHead('商品名称', 'name', '120'),
      new ReplenishmentTableHead('ASIN', 'asin', '120'),
      new ReplenishmentTableHead('计价单位', '_unit', '60'),
      new ReplenishmentTableHead('商品包装尺寸<br>(cm)', 'productSize', '120'),
      new ReplenishmentTableHead('商品包装重量<br>(kg/单位)', 'weight', '120'),
      new ReplenishmentTableHead('箱内该商品数量', '^input-_^num', '100'),
      new ReplenishmentTableHead('箱数', 'numByBox', '60'),
      new ReplenishmentTableHead('剩余未入箱数量', 'numByLast', '80'),
    ]
    return arr
  }
  /**创建进度条数据 */
  static NEWPROGRESSARRAY(){
    let arr = [
      '选择要发补货的店铺及国家站点',
      '选择要发货补充的商品',
      '输入发货数,货件追踪编号,FBA编号等',
      '点击生成FBA发补货计划单'
    ]
    return arr
  }
}

export { ReplenishmentSearchData, ReplenishmentNewModule, ReplenishmentNum, Replenishment }
